module.exports = __webpack_public_path__ + "img/logo-sd-mc.48b4774f.png";